import { useQuery } from '#imports'

export interface SupportOpeningHoursResponse {
    address: string[]
    companyName: string
    companyNumber: string
    email: string
    openingHours: Array<{
        date: string
        day: string
        from: string
        to: string
        hours: Array<{
            from: string
            to: string
            enabled: boolean
            languages: Array<{
                country: string
                enabled: boolean
                language: string
            }>
        }>
        is_open: boolean
        is_today: boolean
    }>
    success: boolean
    support: {
        phonenumber: string
        phonenumberLinkText: string
    }
}
export const useOpeningHours = () => {
    return useQuery<SupportOpeningHoursResponse>('/support_opening_hours/get_opening_hours', { key: 'support_opening_hours:get_opening_hours', enableLegacySupport: true, service: 'monolith' })
}
